export default __webpack_public_path__ + "static/media/englishBrand.fd7051a3.svg";